import { takeLatest } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { createLocation, updateLocation } from '../api';
import { handleFormSubmit } from './helpers/handle-api-form-call';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processSaveLocation(action: any) {
  const { data, formikActions } = action;
  const { id, serviceProviderId } = data;
  yield handleFormSubmit({
    id,
    formikActions,
    updateFn: async () => updateLocation(id, { serviceProviderId, ...data }),
    createFn: async () => createLocation({ serviceProviderId, ...data })
  });
}

export default function* saveLocationSaga() {
  yield takeLatest(AT.SAVE_LOCATION_SAGA, processSaveLocation);
}
